import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createElementVNode as _createElementVNode, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-630e79a3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "relative w-full max-w-2xl bg-white shadow-lg rounded-lg p-8" }
const _hoisted_2 = {
  key: 0,
  class: "flex items-start justify-between p-3 border-b border-solid border-blueGray-200 rounded-t mb-3"
}
const _hoisted_3 = {
  key: 1,
  class: "flex justify-between p-6 border-t border-solid border-blueGray-200 rounded-b"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_Transition, { name: "fade" }, {
    default: _withCtx(() => [
      (_ctx.isModalActive)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "fixed inset-0 w-full h-screen flex items-center justify-center bg-semi-75",
            onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)), ["self"]))
          }, [
            _createElementVNode("div", _hoisted_1, [
              (_ctx.hasSlotHeader)
                ? (_openBlock(), _createElementBlock("header", _hoisted_2, [
                    _renderSlot(_ctx.$slots, "title", {}, undefined, true)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("button", {
                "aria-label": "close",
                class: "absolute top-0 right-0 text-xl text-gray-800 my-2 mx-4",
                onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)), ["prevent"]))
              }, " × "),
              _renderSlot(_ctx.$slots, "default", {}, undefined, true),
              (_ctx.hasSlotFooter)
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                    _renderSlot(_ctx.$slots, "footer", {}, undefined, true)
                  ]))
                : _createCommentVNode("", true)
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 3
  }))
}